import { config } from "@config/config";
import { QuestionDocument, QuestionQuery, QuestionQueryVariables, useQuestionQuery } from "@gql-schema";
import { FaqQuestionPageSection } from "@shared/components/faqs-section/faq-question-page-section";
import { Helmet } from "@shared/components/helmet/helmet";
import { NavBar } from "@shared/components/navbar/navbar";
import { addApolloState, initializeApollo } from "@shared/lib/Apollo";
import { basicStaticProps } from "@shared/utils/basic-static-props";
import { Footer } from "@ui/components/footer/footer";
import { resizerImageUrl } from "@uxf/core/utils/resizer";
import { slugify } from "@uxf/core/utils/slugify";
import { GetStaticProps, NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import React from "react";

export const Page: NextPage = () => {
    const router = useRouter();

    const { data } = useQuestionQuery({
        variables: {
            questionId: parseInt(router.query.id as string, 10),
        },
    });

    if (!data) {
        return null;
    }

    const { id, question, seo, answer } = data.question;

    const metaTitle = seo.title || question;
    const metaDescription = seo.description || answer;

    return (
        <>
            <Helmet
                canonicalUrl={config.FRONTEND_URL + `/caste-otazky/${id}/${slugify(seo.name || question)}`}
                metaTagData={{
                    image: seo.ogImage ? resizerImageUrl(seo.ogImage, 1200, 630, {}) : undefined,
                    metaDescription,
                    metaTitle,
                    ogDescription: seo.ogDescription || metaDescription,
                    ogTitle: seo.ogTitle || metaTitle,
                }}
                title={metaTitle}
            />
            <NavBar />
            <main>
                <FaqQuestionPageSection {...data.question} />
            </main>
            <Footer />
        </>
    );
};

export const getStaticProps: GetStaticProps = basicStaticProps(async ({ locale, params }) => {
    const apolloClient = initializeApollo(null);
    await apolloClient.query<QuestionQuery, QuestionQueryVariables>({
        query: QuestionDocument,
        variables: {
            questionId: parseInt(params?.id as string, 10),
        },
    });

    return addApolloState(apolloClient, {
        props: {
            ...(await serverSideTranslations(locale ?? "cs", ["common"])),
        },
        revalidate: 10,
    });
});

export const getStaticPaths = async () => {
    return {
        paths: [],
        fallback: "blocking",
    };
};
